export enum NodeFileType {
    Video = 1,
    Image = 2,
    Audio = 3,
    InfoIcon = 5,
}